import React from 'react';
import { XOR } from 'types';
import { Option } from './Global';
import { ResolveMultiSelectRef } from 'components/ResolveMultiSelect/types';

export type FilterOption = {
  value: string;
  label: string;
  clearFields?: string[];
  hasCheckboxAll?: boolean;
  isMultiple?: boolean;
} & XOR<
  {
    isSearchable?: boolean;
    shouldSortOptions?: boolean;
    options: Option[];
  },
  {
    render: (params: {
      value: FilterFieldValue;
      onChange: (value: FilterFieldValue) => void;
      selectRef?: React.Ref<ResolveMultiSelectRef>;
      onApply?: () => void;
    }) => React.ReactNode;
    apply?: (value: FilterFieldValue) => Record<string, string>;
    getInitialValue?: (
      activeFilter: Record<string, string>,
    ) => FilterFieldValue;
    isRange?: boolean;
  }
>;

export type FilterFieldValue = string | string[] | Record<string, any> | null;

export type FilterField = {
  name: string;
  value: FilterFieldValue;
};

export type FilterByForm = {
  filters: FilterField[];
};

export type SearchableFilterValue = Option | Option[];

export type HandleChangeSearchableFilter = {
  value: SearchableFilterValue;
  onChange: (value: SearchableFilterValue) => void;
};

export const EMPTY_FILTER_VALUE = '_unknown_';
